import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ShelterIndexPropTypes } from 'dpl/shared/utils/customPropTypes';
import { scrollTo } from 'dpl/shared/utils';
import Map from 'dpl/shelter_search_results/components/Map';
import ResultsList from 'dpl/shelter_search_results/components/ResultsList';
import DetailsContainer from 'dpl/shelter_search_results/containers/DetailsContainer';
import Badge from 'dpl/shelter_search_results/components/Badge';

const LIST_VIEW = 'list';
const MAP_VIEW = 'map';

export default class MobileResults extends Component {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    itemsPerPage: PropTypes.number.isRequired,
    mapIsLoaded: PropTypes.bool.isRequired,
    onMapLoad: PropTypes.func.isRequired,
    onMapUpdate: PropTypes.func.isRequired,
    onShelterClick: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    sheltersData: PropTypes.shape({
      value: PropTypes.shape({
        data: PropTypes.arrayOf(PropTypes.shape(ShelterIndexPropTypes))
          .isRequired,
        meta: PropTypes.shape({
          total_item_count: PropTypes.number
        })
      }).isRequired
    }).isRequired,
    shelterId: PropTypes.number
  };

  static defaultProps = {
    shelterId: null
  };

  state = { view: LIST_VIEW };

  componentDidUpdate(prevProps) {
    if (this.props.shelterId !== prevProps.shelterId) {
      scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  handleViewToggle = view => () => this.setState({ view });

  render() {
    const {
      currentPage,
      itemsPerPage,
      mapIsLoaded,
      onMapLoad,
      onMapUpdate,
      onShelterClick,
      setPage,
      shelterId,
      sheltersData
    } = this.props;

    const {
      value: { data: shelters }
    } = sheltersData;

    const isShelterShown = Boolean(shelterId);

    const isListShown = this.state.view === LIST_VIEW;

    return (
      <div className="ShelterResults relative">
        <div className={classnames('pv4 container', { dn: isShelterShown })}>
          <div className="mb4">
            <div className="flex items-center justify-center tc">
              <button
                className={classnames('ba flex-grow-1 ph4 pv2', {
                  'b--purple bg-purple white': isListShown,
                  'b--light-gray': !isListShown
                })}
                onClick={this.handleViewToggle(LIST_VIEW)}
                type="button"
              >
                List
              </button>
              <button
                className={classnames('ba flex-grow-1 ph4 pv2', {
                  'b--purple bg-purple white': !isListShown,
                  'b--light-gray': isListShown
                })}
                onClick={this.handleViewToggle(MAP_VIEW)}
                type="button"
              >
                Map
              </button>
            </div>
          </div>
          <div className={classnames({ dn: !isListShown })}>
            <ResultsList
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              mapIsLoaded={mapIsLoaded}
              onShelterClick={onShelterClick}
              selectedShelterId={shelterId}
              setPage={setPage}
              sheltersData={sheltersData}
            />
          </div>
          <div className={classnames({ dn: isListShown })}>
            <div className="mb4">
              <Map
                mapIsLoaded={mapIsLoaded}
                onMarkerClick={onShelterClick}
                onMapLoad={onMapLoad}
                onMapUpdate={onMapUpdate}
                shelters={shelters}
              />
            </div>
            <Badge />
          </div>
        </div>
        <div
          className={classnames(
            'ShelterDetailsWrapper transition w-100 h-100 absolute-l overflow-x-hidden overflow-y-auto top-0 bg-white',
            { 'o-0': !isShelterShown }
          )}
        >
          {isShelterShown && <DetailsContainer shelterId={shelterId} />}
        </div>
      </div>
    );
  }
}
